/**
 * L6 tabs-r1 — 홈 「분양 임박 현장」 8행(ImminentRows). TodayStrip 바로 아래 · 지역 탭 위.
 *   행 = 썸 48 · 단지명 · 지역(시도 시군구) · 세대 · [D-n 접수/공고] 배지(DdayPill). 분양가는 홈에 내지 않는다(결정 D9 — /apt 표만).
 *   데이터 = loadImminentLinks(limit 8 · D-60 임박순 · 색인 대상만) + fetchSiteThumbsBySlug. 전부 실값 — 없는 칸은 칸째 생략.
 *   서버 HTML 에 상세 직링크 8개(모든 UA 같은 HTML) — 지역 탭(<button>)은 링크가 아니라서 이 줄이 크롤 경로다.
 * 순수 — 훅·DB 없음. 스타일 home-r1.css(접두 kd-home-).
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import Thumb from '@/components/thumb/Thumb';
import { DdayPill } from '@/components/ds2/Bits';
import type { ThumbData } from '@/lib/thumb/resolve';
import type { ImminentLink } from '@/lib/home/imminent-links';

const WHAT: Record<NonNullable<ImminentLink['kind']>, string> = { subscription: '접수', model_house: '모델하우스', winner_contract: '발표·계약', presale: '공고' };

/** 배지 글자 — 「D-3 접수」·「접수 중」·「D-12 공고」. 날짜 없으면 종전 badge(「분양 임박」). */
export function imminentRowBadge(l: Pick<ImminentLink, 'kind' | 'days' | 'badge'>): string {
  if (typeof l.days !== 'number' || !l.kind) return l.badge;
  const what = WHAT[l.kind];
  if (l.days === 0) return l.kind === 'subscription' ? '접수 중' : `${what} 오늘`;
  return `D-${l.days} ${what}`;
}

export interface ImminentRowsProps {
  rows: readonly ImminentLink[];
  thumbs?: Record<string, ThumbData>;
  /** 섹션 제목(h2). 기본 「분양 임박 현장」. */
  title?: string;
}

const siteHref = (slug: string) => `/apt/${encodeURIComponent(slug)}`;

export default function ImminentRows({ rows, thumbs = {}, title = '분양 임박 현장' }: ImminentRowsProps) {
  if (!rows.length) return null;
  return (
    <section className="kd-home-imm" aria-labelledby="kd-home-imm-h" data-cl-section="imminent">
      <div className="ds2-wrap">
        <div className="kd-home-imm__head">
          <h2 id="kd-home-imm-h" className="kd-home-imm__h">{title}</h2>
          <a className="kd-home-imm__more" href="/apt">전체 일정 →</a>
        </div>
        <ol className="kd-home-imm__list">
          {rows.map((l) => {
            const where = [l.region, l.sigungu].filter(Boolean).join(' ');
            const t = thumbs[l.slug];
            return (
              <li key={l.slug} className="kd-home-imm__row" data-imm-kind={l.kind ?? undefined}>
                <a href={siteHref(l.slug)} className="kd-home-imm__a">
                  {t ? <span className="kd-home-imm__th"><Thumb data={t} w={48} h={48} /></span> : null}
                  <span className="kd-home-imm__body">
                    <b className="kd-home-imm__name">{l.name}</b>
                    <span className="kd-home-imm__meta">
                      {where ? <span>{where}</span> : null}
                      {l.units ? <span className="kd-home-imm__u">{l.units.toLocaleString('ko-KR')}세대</span> : null}
                    </span>
                  </span>
                  <span className="kd-home-imm__dd"><DdayPill days={l.days} label={imminentRowBadge(l)} /></span>
                </a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
